import { useEffect, useState } from 'react';
import { getTelegram } from './telegram.js';
import { Button, Screen } from './ui.js';

export function DeletionCompletion() {
  const [seconds, setSeconds] = useState(5);
  useEffect(() => {
    const startedAt = Date.now();
    const timer = window.setInterval(() => {
      const remaining = Math.max(0, 5 - Math.floor((Date.now() - startedAt) / 1000));
      setSeconds(remaining);
      if (remaining === 0) {
        window.clearInterval(timer);
        getTelegram()?.disableClosingConfirmation?.();
        getTelegram()?.close();
      }
    }, 250);
    return () => window.clearInterval(timer);
  }, []);
  return (
    <Screen title="Аккаунт закрыт">
      <p role="status">Запрос на удаление принят ✅. Восстановление невозможно.</p>
      <p>
        {seconds > 0
          ? `Приложение закроется через ${seconds} сек.`
          : 'Закройте приложение и откройте его заново для регистрации.'}
      </p>
      <Button onClick={() => getTelegram()?.close()}>Закрыть приложение</Button>
    </Screen>
  );
}
